module.exports = __webpack_public_path__ + "img/photo-location.a518235f.png";